import { render, staticRenderFns } from "./attachment-form.vue?vue&type=template&id=177a96ce&scoped=true"
import script from "./attachment-form.vue?vue&type=script&lang=js"
export * from "./attachment-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177a96ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('177a96ce')) {
      api.createRecord('177a96ce', component.options)
    } else {
      api.reload('177a96ce', component.options)
    }
    module.hot.accept("./attachment-form.vue?vue&type=template&id=177a96ce&scoped=true", function () {
      api.rerender('177a96ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/attachment/attachment-form.vue"
export default component.exports